export default __webpack_public_path__ + "static/media/aleksandar_xl.f0ad4b55.jpg";